(() => {
  const initialiseNavigation = (scope = document) => {
    if (typeof window.Splide === "undefined") return;

    scope
      .querySelectorAll("[data-collection-showcase-navigation]")
      .forEach((navigation) => {
        if (navigation.dataset.navigationInitialised === "true") return;

        const section = navigation.closest(".collection-product-showcase");
        const navigationMode =
          section?.dataset.collectionNavigationMode || "toggle";
        const wrapper = navigation.closest(
          ".collection-product-showcase__navigation-wrapper",
        );
        const previousButton = wrapper?.querySelector(
          "[data-collection-navigation-previous]",
        );
        const nextButton = wrapper?.querySelector(
          "[data-collection-navigation-next]",
        );
        const pagination = wrapper?.querySelector(
          "[data-collection-navigation-pagination]",
        );
        const filters = [
          ...navigation.querySelectorAll("[data-collection-showcase-filter]"),
        ];
        const rows = [
          ...(section?.querySelectorAll("[data-collection-showcase-row]") ||
            []),
        ];
        let suppressFilterClick = false;
        let pointerStartX = null;
        let pointerTravel = 0;
        let blockClicksUntil = 0;
        let activeFilterIndex = navigationMode === "scroll" ? 0 : -1;
        let scrollFrame = null;

        navigation.addEventListener(
          "pointerdown",
          (event) => {
            pointerStartX = event.clientX;
            pointerTravel = 0;
          },
          true,
        );

        navigation.addEventListener(
          "pointermove",
          (event) => {
            if (pointerStartX === null) return;
            pointerTravel = Math.max(
              pointerTravel,
              Math.abs(event.clientX - pointerStartX),
            );
          },
          true,
        );

        const finishPointerInteraction = () => {
          if (pointerTravel > 5) {
            blockClicksUntil = performance.now() + 300;
          }
          pointerStartX = null;
        };

        navigation.addEventListener(
          "pointerup",
          finishPointerInteraction,
          true,
        );
        navigation.addEventListener(
          "pointercancel",
          finishPointerInteraction,
          true,
        );

        const slider = new window.Splide(navigation, {
          type: "slide",
          autoWidth: true,
          gap: "20px",
          perMove: 1,
          speed: 500,
          arrows: false,
          pagination: false,
          drag: true,
          keyboard: "focused",
          omitEnd: true,
          breakpoints: {
            989: {
              gap: "12px",
            },
            749: {
              gap: "10px",
            },
          },
        });

        const updateArrowState = () => {
          if (previousButton) previousButton.disabled = slider.index === 0;
          if (nextButton) {
            nextButton.disabled =
              slider.index >= slider.Components.Controller.getEnd();
          }
        };

        const updatePagination = () => {
          if (!pagination) return;
          const end = slider.Components.Controller.getEnd();
          const pageCount = Math.max(1, end + 1);
          if (pagination.children.length !== pageCount) {
            pagination.replaceChildren(
              ...Array.from({ length: pageCount }, () => {
                const page = document.createElement("span");
                page.className = "collection-product-showcase__navigation-page";
                return page;
              }),
            );
          }
          const currentPage = Math.min(slider.index, pageCount - 1);
          [...pagination.children].forEach((page, index) => {
            page.classList.toggle("is-active", index === currentPage);
          });
        };

        previousButton?.addEventListener("click", () => slider.go("<"));
        nextButton?.addEventListener("click", () => slider.go(">"));

        const setActiveFilter = (filterIndex, moveNavigation = true) => {
          if (filterIndex < 0 || filterIndex >= filters.length) return;

          filters.forEach((button, index) => {
            const isActive = index === filterIndex;
            button.classList.toggle("is-filter-active", isActive);
            button.setAttribute("aria-pressed", String(isActive));
          });

          if (moveNavigation && activeFilterIndex !== filterIndex) {
            slider.go(filterIndex);
          }
          activeFilterIndex = filterIndex;
        };

        filters.forEach((filter, filterIndex) => {
          filter.addEventListener("click", (event) => {
            if (
              suppressFilterClick ||
              pointerTravel > 5 ||
              performance.now() < blockClicksUntil
            ) {
              event.preventDefault();
              event.stopPropagation();
              return;
            }

            const selectedFilter = filter.dataset.collectionShowcaseFilter;
            setActiveFilter(filterIndex, false);

            if (
              navigationMode === "toggle" &&
              section?.classList.contains(
                "collection-product-showcase--product-grid",
              )
            ) {
              section.classList.toggle(
                "collection-product-showcase--all-categories-active",
                selectedFilter === "all",
              );
            }

            if (navigationMode === "scroll") {
              const selectedRow = rows.find(
                (row) => row.dataset.collectionShowcaseRow === selectedFilter,
              );
              selectedRow?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            } else {
              rows.forEach((row) => {
                row.hidden =
                  selectedFilter !== "all" &&
                  row.dataset.collectionShowcaseRow !== selectedFilter;
              });
            }

            slider.go(filterIndex);
          });
        });

        if (navigationMode === "scroll" && rows.length) {
          const updateActiveFilterFromScroll = () => {
            scrollFrame = null;
            if (!section?.isConnected) {
              document.body.classList.remove(
                "collection-showcase-scroll-navigation-active",
              );
              return;
            }

            const sectionRect = section.getBoundingClientRect();
            const navigationHeight = wrapper?.offsetHeight || 0;
            const navigationIsPinned =
              sectionRect.top <= 0 && sectionRect.bottom > navigationHeight;
            document.body.classList.toggle(
              "collection-showcase-scroll-navigation-active",
              navigationIsPinned,
            );

            const activationLine = Math.max(40, navigationHeight) + 60;
            let activeRow = rows[0];
            rows.forEach((row) => {
              if (row.getBoundingClientRect().top <= activationLine) {
                activeRow = row;
              }
            });
            const filterIndex = filters.findIndex(
              (filter) =>
                filter.dataset.collectionShowcaseFilter ===
                activeRow.dataset.collectionShowcaseRow,
            );
            setActiveFilter(filterIndex);
          };

          const requestScrollUpdate = () => {
            if (scrollFrame !== null) return;
            scrollFrame = window.requestAnimationFrame(
              updateActiveFilterFromScroll,
            );
          };

          window.addEventListener("scroll", requestScrollUpdate, {
            passive: true,
          });
          window.addEventListener("resize", requestScrollUpdate);
          requestScrollUpdate();
        }

        slider.on("drag", () => {
          suppressFilterClick = true;
        });
        slider.on("dragged", () => {
          window.setTimeout(() => {
            suppressFilterClick = false;
          }, 0);
        });
        slider.on("mounted moved resized updated", () => {
          updateArrowState();
          updatePagination();
        });
        slider.mount();

        navigation.dataset.navigationInitialised = "true";
        navigation.collectionNavigationSplide = slider;
        updateArrowState();
        updatePagination();
      });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initialiseNavigation());
  } else {
    initialiseNavigation();
  }

  window.addEventListener("load", () => initialiseNavigation());
  document.addEventListener("shopify:section:load", (event) => {
    initialiseNavigation(event.target);
  });
})();
